module.exports = __webpack_public_path__ + "static/media/branch.bd86efef.svg";